module.exports = "<svg viewBox=\"0 0 40.1 35.4\"><path d=\"M40.1 25.7h-7.8V13.5H7.8v12.2H0v-20h40.1z\" class=\"st0\"></path><g class=\"st1\"><path d=\"M11 0h18v7.8H11z\" class=\"st0\"></path></g><path d=\"M12.1 17.7v17.7h15.8V17.7\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/printer.svg
// module id = 305
// module chunks = 1